'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoLogoGithub = function GoLogoGithub(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm7.7 17.5h-3.4c0 0-0.1 0.1-0.1 0.1v1.7c0 0.1 0.1 0.2 0.1 0.2h1.4v2s-0.3 0.1-1.1 0.1c-1 0-2.4-0.4-2.4-3.3 0-3 1.4-3.4 2.8-3.4 1.1 0 1.6 0.2 1.9 0.3 0.1 0.1 0.2 0 0.2-0.1l0.4-1.6c0 0-0.1-0.1-0.1-0.1-0.1-0.1-0.9-0.5-2.8-0.5-2.3 0-4.6 0.9-4.6 5.5 0 4.6 2.6 5.3 4.9 5.3 1.8 0 2.9-0.8 2.9-0.8 0.1 0 0.1-0.1 0.1-0.1v-5.2c0 0-0.1-0.1-0.2-0.1z m17-4.2h-1.9c-0.1 0-0.1 0-0.1 0.1v3.7h-3v-3.7c0-0.1 0-0.1-0.1-0.1h-1.9c-0.1 0-0.2 0-0.2 0.1v9.9c0 0.1 0.1 0.2 0.2 0.2h1.9c0.1 0 0.1-0.1 0.1-0.2v-4.2h3l0 4.2c0 0.1 0 0.2 0.1 0.2h1.9c0.1 0 0.2-0.1 0.2-0.2l0-9.9c0-0.1-0.1-0.2-0.2-0.2z m-14.7 0.2c-0.7 0-1.2 0.5-1.2 1.2s0.5 1.2 1.2 1.2 1.2-0.5 1.2-1.2c0-0.7-0.6-1.2-1.2-1.2z m1.1 3.2c0-0.1-0.1-0.2-0.2-0.2h-1.9c-0.1 0-0.1 0.1-0.1 0.2v6.5c0 0.2 0.1 0.3 0.2 0.3h1.7c0.2 0 0.3-0.1 0.3-0.3 0-0.3 0-1.7 0-2 0-0.2 0-4.5 0-4.5z m21-0.2h-1.9c-0.1 0-0.2 0.1-0.2 0.2v4.8s-0.5 0.4-1.1 0.4c-0.7 0-0.9-0.3-0.9-1v-4.2c0-0.1-0.1-0.2-0.1-0.2h-2c0 0-0.1 0.1-0.1 0.2v4.5s1.1 2.5 2.6 2.5c1.2 0 2.2-0.7 2.2-0.7s0.1 0.4 0.1 0.4c0 0 0.1 0.1 0.2 0.1h1.2c0 0 0.1-0.1 0.1-0.2l0-6.6c0-0.1-0.1-0.2-0.1-0.2z m5.1-0.2c-1.1 0-1.8 0.5-1.8 0.5v-3.4c0-0.1-0.1-0.1-0.1-0.1h-1.9c-0.1 0-0.2 0-0.2 0.1l0 9.9c0 0.1 0.1 0.2 0.2 0.2h1.3c0 0 0.1-0.1 0.1-0.1 0-0.1 0.1-0.5 0.1-0.5s0.8 0.8 2.2 0.8c1.8 0 2.8-0.9 2.8-4 0-3-1.6-3.4-2.7-3.4z m-0.7 5.6c-0.7 0-1.1-0.3-1.1-0.3v-3.2s0.4-0.3 0.9-0.3c0.7-0.1 1.4 0.1 1.4 1.8 0 1.7-0.3 2-1.2 2z m-20-0.1c0 0-0.3 0.1-0.5 0.1-0.7 0-0.9-0.4-0.9-0.8v-2.8h1.4c0.1 0 0.2 0 0.2-0.1v-1.5c0-0.1-0.1-0.2-0.2-0.2h-1.4l0-1.9c0-0.1-0.1-0.1-0.1-0.1h-2c0 0-0.1 0-0.1 0.1v2s-1 0.2-1 0.2c-0.1 0-0.1 0.1-0.1 0.2v1.2c0 0.1 0 0.1 0.1 0.1h1v3c0 2.1 1.5 2.4 2.6 2.4 0.4 0 1-0.2 1.1-0.2 0.1 0 0.1-0.1 0.1-0.2l0-1.3c0-0.1-0.1-0.2-0.2-0.2z' })
        )
    );
};

exports.default = GoLogoGithub;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/go/logo-github.js
// module id = 1752
// module chunks = 0